import { get, getDatabase, ref, set } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { recordActivity } from './activityApi';

const INSTANCE_NAME_PATH = 'global/instanceName';

/** Read the customer/instance name shown in navigation and config exports. */
export async function getInstanceName(): Promise<string | null> {
    const db = getDatabase();
    const snapshot = await get(ref(db, INSTANCE_NAME_PATH));
    return snapshot.exists() && typeof snapshot.val() === 'string' ? snapshot.val() : null;
}

export async function setInstanceName(name: string): Promise<void> {
    const auth = getAuth();
    if (!auth.currentUser) {
        throw new Error('Du måste vara inloggad för att ändra instansnamnet');
    }

    const trimmed = name.trim();
    if (!trimmed) {
        throw new Error('Instansnamn krävs');
    }

    try {
        const db = getDatabase();
        await set(ref(db, INSTANCE_NAME_PATH), trimmed);
    } catch (err) {
        console.error('Failed to save instance name', err);
        throw new Error('Kunde inte spara instansnamnet. Försök igen.');
    }
    recordActivity('settings.updated');
}
